import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Button from "../../components/Button/Button";
import TwoColumns from "../../components/TwoColumns/TwoColumns";
import FormActions from "../../components/FormActions/FormActions";
import Input from "../../components/Input/Input";
import { withFirebase } from "../../components/Firebase/Firebase";
import {
	stateOptions,
	socialIssueOptions,
	howDidYouHearAboutUsOptions,
	validEmail
} from "../../config";
import { withPrismic } from "../../components/Prismic/Prismic";
import RichText from "../../components/RichText/RichText";
import moment from "moment";

class Stage2 extends Component {
	state = {
		inputs: {
			entry_first_name: "",
			entry_last_name: "",
			entry_email: "",
			entry_mobile: "",
			title: "",
			state: "",
			issue: "",
			created: moment().toISOString(),
			numberOfMembersInYourTeam: "",
			fullNamesOfAllTeamMembers: "",
			fullNamesOfAnyOtherPeopleWhoAppearInYourVideo: "",
			howYouHeardAboutVideosForChange: "",
			// locationReleaseForm:  "",
			// locationReleaseWaived : false,
			indigenous: "",
			remote: "",
			teacher: "",
			grade: "",
			schoolOrYouthName: "",
			teacherFirstName: "",
			teacherLastName: "",
			teacherEmailAddress: ""
		}
	};

  async componentDidMount() {
		// If we already have data lets prepopulate state

		if (this.props.id && this.props.entries[this.props.id]) {
			const entryData = this.props.entries[this.props.id];
			this.setState({
				id: this.props.id,
				inputs: {
					...this.state.inputs,
					...entryData
				}
			});
		} else {
      const id = await this.props.methods.newEntry(this.props.competitionId);
      this.setState({ id });
		}

	}
	
	continue = async () => {
		const { id } = this.state;

		await this.props.methods.updateEntryData(id, this.state.inputs);
		await this.props.methods.updateEntryStage(id, 5);
    this.props.history.push(`/competition/${this.props.slug}/enter/${id}`);
	};
	
	handleInputEvent = (e, key) => {
		this.setState({
			inputs: {
				...this.state.inputs,
				[key]: e.target.value
			}
		});
	};
	
	handleCheckboxEvent = (e, key) => {
		this.setState({
			inputs: {
				...this.state.inputs,
				[key]: !this.state.inputs[key]
			}
		});
	};

	// This is a custom handler, it will update state with the new filename and pass the update back to firebase
	handleLocationFileUpload = (filename, key) => {
		this.setState({
			inputs: {
				...this.state.inputs,
				[key]: filename
			}
		});
	};
	
	isValid = () => {
		let isValid = true;
		if (!this.state.inputs.entry_first_name) {
			isValid = false;
		}
		if (!this.state.inputs.entry_last_name) {
			isValid = false;
		}
		if (!(this.state.inputs.entry_email && validEmail.test(String(this.state.inputs.entry_email).toLowerCase()))) {
			isValid = false;
		}
		if (!(this.state.inputs.entry_mobile && this.state.inputs.entry_mobile.length >= 10)) {
			isValid = false;
		}
		if (!this.state.inputs.title) {
			isValid = false;
		}
		if (!this.state.inputs.state) {
			isValid = false;
		}
		if (!this.state.inputs.issue) {
			isValid = false;
		}
		if (!this.state.inputs.numberOfMembersInYourTeam) {
			isValid = false;
		}
		if (Number(this.state.inputs.numberOfMembersInYourTeam) !== 1 && !this.state.inputs.fullNamesOfAllTeamMembers) {
			isValid = false;
		}
		// if (!this.state.inputs.fullNamesOfAnyOtherPeopleWhoAppearInYourVideo) {
		// 	isValid = false;
		// }
		if (!this.state.inputs.howYouHeardAboutVideosForChange) {
			isValid = false;
		}
		if (!this.state.inputs.indigenous) {
			isValid = false;
		}
		if (!this.state.inputs.teacher) {
			isValid = false;
		}
		if (!this.state.inputs.grade) {
			isValid = false;
		}
		if (this.state.inputs.teacher === 'yes' && !this.state.inputs.schoolOrYouthName) {
			isValid = false;
		}
		if (this.state.inputs.teacher === 'yes' && !this.state.inputs.teacherFirstName) {
			isValid = false;
		}
		if (this.state.inputs.teacher === 'yes' && !this.state.inputs.teacherLastName) {
			isValid = false;
		}
		// if(!this.state.inputs.locationReleaseForm && !this.state.inputs.locationReleaseWaived) {
		// 	isValid = false;
		// }
		return isValid;
	};
	
	render() {

		if(!this.props.terms) return null;

		return (
			<div>


			<RichText content={this.props.terms.stage_2} />
			
			<TwoColumns
			left={
				<div>

				<Input
				title="Your First Name"
				type="text"
				value={this.state.inputs.entry_first_name}
				onChange={e => this.handleInputEvent(e, "entry_first_name")}
				validate={value => value}
				required
				maxlength={30}
				/>

				<Input
				title="Your Last Name"
				type="text"
				value={this.state.inputs.entry_last_name}
				onChange={e => this.handleInputEvent(e, "entry_last_name")}
				validate={value => value}
				required
				maxlength={30}
				/>
				<Input
				title="Your Email Address"
				type="email"
				value={this.state.inputs.entry_email}
				onChange={e => this.handleInputEvent(e, "entry_email")}
				validate={email => validEmail.test(String(email).toLowerCase())}
				required
				/>
				<Input
				title="Your Mobile or Home Phone Number (incl Area Code)"
				type="text"
				value={this.state.inputs.entry_mobile}
				onChange={e => this.handleInputEvent(e, "entry_mobile")}
				validate={value => value && value.length >= 10}
				minlength={10}
				maxlength={12}
				required
				/>
				<Input
				title="Video title (50 characters)"
				value={this.state.inputs.title}
				onChange={e => this.handleInputEvent(e, "title")}
				validate={value => value}
				maxlength={50}
				required
				/>
				<Input
				title="State"
				value={this.state.inputs.state}
				type="dropdown"
				required
				options={{
					"": "Select One",
					...stateOptions
				}}
				validate={value => value}
				onChange={e => this.handleInputEvent(e, "state")}
				/>
				<Input
				title="Social Issue"
				value={this.state.inputs.issue}
				type="dropdown"
				required
				options={{
					"": "Select One",
					...socialIssueOptions
				}}
				validate={value => value}
				onChange={e => this.handleInputEvent(e, "issue")}
				/>
				<Input
				title="Number of members in your film-making team (max 6)"
				value={this.state.inputs.numberOfMembersInYourTeam}
				validate={value => value}
				required
				onChange={e => this.handleInputEvent(e, "numberOfMembersInYourTeam")}
				/>
				<Input
				title="Please enter full names of all team members, separating each name with a comma"
				value={this.state.inputs.fullNamesOfAllTeamMembers}
				type="textarea"
				required
				validate={value => Number(this.state.inputs.numberOfMembersInYourTeam) === 1 ? true : value}
				onChange={e => this.handleInputEvent(e, "fullNamesOfAllTeamMembers")}
				/>
				<Input
				title="Please enter full names of any other people who appear in your video (talent), separating each name with a comma"
				value={this.state.inputs.fullNamesOfAnyOtherPeopleWhoAppearInYourVideo}
				type="textarea"
				// required
				// validate={value => value}
				onChange={e => this.handleInputEvent(e, "fullNamesOfAnyOtherPeopleWhoAppearInYourVideo")}
				/>
				</div>
			}
			right={
				<div>

				<Input
				title="How did you first hear about videos for change?"
				value={this.state.inputs.howYouHeardAboutVideosForChange}
				type="dropdown"
				options={{
					"": "Select One",
					...howDidYouHearAboutUsOptions
				}}
				required
				validate={value => value}
				onChange={e =>
					this.handleInputEvent(e, "howYouHeardAboutVideosForChange")
				}
				/>

				<Input
				title="Are you, or one of the key members of your team of Aboriginal and/or Torres Strait Islander descent?"
				value={this.state.inputs.indigenous}
				type="dropdown"
				required
				validate={value => value}
				options={{
					"": "Select One",
					yes: "Yes",
					no: "No"
				}}
				onChange={e => this.handleInputEvent(e, "indigenous")}
				/>

				<Input
				title="If you created your video at school or a youth group, was there a teacher/facilitator that supported you to enter?"
				value={this.state.inputs.teacher}
				type="dropdown"
				required
				validate={value => value}
				options={{
					"": "Select One",
					yes: "Yes",
					no: "No"
				}}
				onChange={e => this.handleInputEvent(e, "teacher")}
				/>
				{this.state.inputs.teacher === "yes" && (
					<div>
						<p>Please tell us their name and if possible, an email address, so we can let them know if you become a finalist!</p>
					<Input
					title="School or Youth Group Name"
					value={this.state.inputs.schoolOrYouthName}
					onChange={e => this.handleInputEvent(e, "schoolOrYouthName")}
					validate={value => value}
					required
					/>
					<Input
					title="Teacher First Name"
					value={this.state.inputs.teacherFirstName}
					onChange={e => this.handleInputEvent(e, "teacherFirstName")}
					validate={value => value}
					required
					/>
					<Input
					title="Teacher Last Name"
					value={this.state.inputs.teacherLastName}
					onChange={e => this.handleInputEvent(e, "teacherLastName")}
					validate={value => value}
					required
					/>
					<Input
					title="Teacher Email Address"
					type="email"
					value={this.state.inputs.teacherEmailAddress}
					onChange={e =>
						this.handleInputEvent(e, "teacherEmailAddress")
					}
					// validate={email => validEmail.test(String(email).toLowerCase())}
					/>
					</div>
				)}

				<Input
					title="School Grade of Oldest Team Member"
					value={this.state.inputs.grade}
					type="dropdown"
					validate={value => value}
					required
					options={{
						0: "Select One",
						7: "7",
						8: "8",
						9: "9",
						10: "10",
						11: "11",
						12: "12",
					}}
					onChange={e => this.handleInputEvent(e, "grade")}
				/>

				{/*<Input*/}
				{/*title="Location Release Form"*/}
				{/*value={this.state.inputs.locationReleaseForm}*/}
				{/*type="file"*/}
				{/*onComplete={filename =>*/}
					{/*this.handleLocationFileUpload(filename, "locationReleaseForm")*/}
				{/*}*/}
				{/*filePath={`locationreleaseforms/${this.props.id}/`}*/}
				{/*validate={value => value}*/}
				{/*/>*/}
				{/*<p className="-fineprint">Download and complete a <a href="https://videosforchange.cdn.prismic.io/videosforchange%2F66712acb-9581-4072-a400-518564cc4d54_180705_location+release+form.pdf" target="_blank" rel="noopener noreferrer">Location Release Form</a></p>*/}
				
				{/*<div className="checkbox">*/}
					{/*<label htmlFor="locationReleaseWaived">*/}
						{/*<input type="checkbox" name="locationReleaseWaived" id="locationReleaseWaived" checked={this.state.inputs.locationReleaseWaived} onChange={e => this.handleCheckboxEvent(e, 'locationReleaseWaived')} />*/}
						{/*I don't need to submit a location release form*/}
					{/*</label>*/}
				{/*</div>*/}


				</div>
			}
			/>
			
			<FormActions
			left={<div />}
			right={
				<div>
				<Button type={["primary","emphasis"]} onClick={this.continue} disabled={!this.isValid()}>
				Continue
				</Button>
				</div>
			}
			/>
			</div>
		);
	}
}

export default withRouter(withPrismic(withFirebase(Stage2)));



// WEBPACK FOOTER //
// ./src/pages/CompetitionEnter/Stage2.js